import { EntityDelegacion } from "../../../shared/Domain/EntityDelegacion";
import { RepositoryMain } from "../Domain/RepositoryMain";

export class UseCaseSelectDelegacion {
    private repository: RepositoryMain;

    constructor(_repository: RepositoryMain) {
        this.repository = _repository;
    }

    public async exec(): Promise<Array<EntityDelegacion>> {
        return await this._exec();
    }

    private async _exec(): Promise<Array<EntityDelegacion>> {
        return await this.repository.selectDelegaciones();
    }
}